export const RECORD_LOAD = "record/on_load";
export const recordLoad = () => ({
  type: RECORD_LOAD,
});

export const RECORD_LOAD_SUCCESS = "record/on_load_success";
export const recordLoadSuccess = (data, recordData) => ({
  type: RECORD_LOAD_SUCCESS,
  payload: {
    plan: data,
    recordData: recordData
  }
});

export const RECORDED_DELETE = "record/delete_recorded";
export const recordedDelete = (data) => ({
  type: RECORDED_DELETE,
  payload: data
});

export const RECORDED_ADD = "record/add_recorded";
export const recordedAdd = (data, url) => ({
  type: RECORDED_ADD,
  payload: data,
  url: url
});

export const RECORDED_REMOVE = "record/remove_recorded";
export const recordedRemove = (data, url) => ({
  type: RECORDED_REMOVE,
  payload: data,
  url: url
});

export const RECORDED_REFRESH = "record/refresh_recorded";
export const recordedRefresh = () => ({
  type: RECORDED_REFRESH
});

export const RECORD_ACTION_SUCCESS = "record/action_success";
export const recordActionSuccess = (data) => ({
  type: RECORD_ACTION_SUCCESS,
  payload: data
});

export const RECORD_ACTION_ERROR = "record/action_error";
export const recordActionError = (err) => ({
  type: RECORD_ACTION_ERROR,
  payload: err
});

export const RECORD_ACTION_ERROR_CLEAR = "record/action_error_clear";
export const recordActionErrorClear = () => ({
  type: RECORD_ACTION_ERROR_CLEAR
});

export const RECORDED_GET = "record/get_recorded";
export const recordedGet = (data) => ({
  type: RECORDED_GET,
  payload: data
});

export const RECORDED_GET_SUCCESS = "record/get_recorded_success";
export const recordGetSuccess = (data, recorded, epg) => ({
  type: RECORDED_GET_SUCCESS,
  payload: data,
  recorded: recorded,
  epg: epg
});

export const RECORDED_GET_CLEAR = "record/get_recorded_clear";
export const recordGetClear = () => ({
  type: RECORDED_GET_CLEAR
});

export const RECORDED_EPG_GET = "record/epg_get";
export const recordedEpgGet = (data) => ({
  type: RECORDED_EPG_GET,
  payload: data
});
